import React from "react";
import {
    Card,
    CardHeader,
    CardFooter,
    Text,
    Button,
} from "@fluentui/react-components";

type Props = {
    children: React.ReactNode;
};

type State = {
    hasError: boolean;
    error?: Error;
    errorInfo?: React.ErrorInfo;
};

export class ErrorBoundary extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(_: Error): State {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        console.error("Uncaught error:", error, errorInfo);
        this.setState({ error, errorInfo });
    }

    handleReload = () => {
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <div style={{ padding: "1rem", maxWidth: "600px", margin: "2rem auto" }}>
                    <Card>
                        <CardHeader
                            header={<Text weight="semibold">Something went wrong.</Text>}
                        />
                        <div style={{ padding: "1rem" }}>
                            {this.state.error && (
                                <Text as="p" style={{ color: "red" }}>
                                    {this.state.error.toString()}
                                </Text>
                            )}
                            {this.state.errorInfo && (
                                <pre style={{ fontSize: "12px", whiteSpace: "pre-wrap", marginTop: "1rem" }}>
                                    {this.state.errorInfo.componentStack}
                                </pre>
                            )}
                        </div>
                        <CardFooter>
                            <Button appearance="primary" onClick={this.handleReload}>
                                Reload Page
                            </Button>
                        </CardFooter>
                    </Card>
                </div>
            );
        }

        return this.props.children;
    }
}
